import React from 'react';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { getLocalCurrencyStr } from '@beef/utils';
import classNames from 'classnames/bind';
import { StrikePrice } from "../StrikePrice";
import styles from "./styles.pcss";
import { getPeriodTextByDay } from "../../utils";
var cn = classNames.bind(styles);
export var TariffTitle = function TariffTitle(_ref) {
  var title = _ref.title,
    price = _ref.price,
    periodDays = _ref.periodDays,
    _ref$isComposePeriodD = _ref.isComposePeriodDay,
    isComposePeriodDay = _ref$isComposePeriodD === void 0 ? false : _ref$isComposePeriodD,
    nextValue = _ref.nextValue,
    trialEndDate = _ref.trialEndDate;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('title'),
    "data-t-id": "components-TariffTitle"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('name'),
    variant: isMobile ? 'body-small' : 'body-large'
  }, title), /*#__PURE__*/React.createElement("div", {
    className: cn('period')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: isMobile ? 'xs' : 's'
  }, getLocalCurrencyStr(price)), periodDays && /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: isMobile ? 'xs' : 's'
  }, isComposePeriodDay ? "/".concat(getPeriodTextByDay(periodDays)) : periodDays), /*#__PURE__*/React.createElement(StrikePrice, {
    nextValue: nextValue,
    shouldRender: Boolean(nextValue && trialEndDate),
    trialEndDate: trialEndDate
  })));
};